(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal(scope) {
    var root = scope || document;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bt-reveal]'));

    items.forEach(function (item) {
      var delay = parseInt(item.getAttribute('data-bt-reveal-delay') || '0', 10);
      item.style.setProperty('--bt-reveal-delay', delay + 'ms');
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (item) {
      if (!item.classList.contains('is-visible')) observer.observe(item);
    });
  }

  function initRail(section) {
    if (!section || section.dataset.btRailReady === 'true') return;

    var rail = section.querySelector('[data-bt-rail]');
    var previous = section.querySelector('[data-bt-rail-prev]');
    var next = section.querySelector('[data-bt-rail-next]');
    if (!rail || !previous || !next) return;

    section.dataset.btRailReady = 'true';

    function scrollAmount() {
      var card = rail.querySelector('.bt-editorial-card');
      if (!card) return rail.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(rail).columnGap || '0');
      return card.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 3;
      next.disabled = rail.scrollLeft >= maxScroll - 3;
    }

    previous.addEventListener('click', function () {
      rail.scrollBy({ left: -scrollAmount(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });

    next.addEventListener('click', function () {
      rail.scrollBy({ left: scrollAmount(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });

    rail.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      rail.scrollBy({
        left: event.key === 'ArrowLeft' ? -scrollAmount() : scrollAmount(),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    });

    rail.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function respectMotionPreference(scope) {
    if (!reduceMotion.matches) return;
    (scope || document).querySelectorAll('.bt-home-section video').forEach(function (video) {
      video.pause();
      video.removeAttribute('autoplay');
    });
  }

  function init(scope) {
    if (!document.body.classList.contains('template-index')) return;
    document.body.classList.add('bt-is-reveal-ready');
    initReveal(scope || document);
    (scope || document).querySelectorAll('[data-bt-rail-section]').forEach(initRail);
    respectMotionPreference(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());
